__turbopack_context__.v({
  "item": "style-module-scss-module__3pnU5W__item",
  "items": "style-module-scss-module__3pnU5W__items",
  "line": "style-module-scss-module__3pnU5W__line",
  "note": "style-module-scss-module__3pnU5W__note",
  "price": "style-module-scss-module__3pnU5W__price",
  "root": "style-module-scss-module__3pnU5W__root",
  "title": "style-module-scss-module__3pnU5W__title",
});
